import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.64645 4.14645C8.84171 3.95118 9.15829 3.95118 9.35355 4.14645L16.8536 11.6464C17.0488 11.8417 17.0488 12.1583 16.8536 12.3536L9.35355 19.8536C9.15829 20.0488 8.84171 20.0488 8.64645 19.8536C8.45118 19.6583 8.45118 19.3417 8.64645 19.1464L15.7929 12L8.64645 4.85355C8.45118 4.65829 8.45118 4.34171 8.64645 4.14645Z"
});
var roundLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.64645 4.14645C8.84171 3.95118 9.15829 3.95118 9.35355 4.14645L16.8536 11.6464C17.0488 11.8417 17.0488 12.1583 16.8536 12.3536L9.35355 19.8536C9.15829 20.0488 8.84171 20.0488 8.64645 19.8536C8.45118 19.6583 8.45118 19.3417 8.64645 19.1464L15.7929 12L8.64645 4.85355C8.45118 4.65829 8.45118 4.34171 8.64645 4.14645Z"
});
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.00001 3.99316L17.0071 12.0003L9.00001 20.0074L8.29291 19.3003L15.5929 12.0003L8.29291 4.70027L9.00001 3.99316Z"
});
var sharpLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.00001 3.99316L17.0071 12.0003L9.00001 20.0074L8.29291 19.3003L15.5929 12.0003L8.29291 4.70027L9.00001 3.99316Z"
});
var IconChevronRight = makeIcon('IconChevronRight', 'Chevron Right', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconChevronRight;